import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

const server_url = process.env.REACT_APP_BACKEND_URL;

interface AuthContextType {
  session: any;
  role: string;
  isAuthenticated: boolean;
  isLoading: boolean;
  setSession: (session: any) => void;
}

export const AuthContext = createContext<AuthContextType>({
  session: null,
  role: "",
  isAuthenticated: false,
  isLoading: true,
  setSession: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [session, setSessionState] = useState<any>(null);
  const [role, setRole] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeAuth = async () => {
      const storedSession = localStorage.getItem("session");
      if (storedSession) {
        const parsedSession = JSON.parse(storedSession);
        setSessionState(parsedSession);
        const isValid = await verifySession(parsedSession);
        if (isValid) {
          const token = parsedSession.access_token;
          const payload = JSON.parse(window.atob(token.split(".")[1]));
          const user_role = payload.user_role;
          setRole(user_role);
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem("session");
          setSessionState(null);
          setRole("");
          setIsAuthenticated(false);
        }
      }
      setIsLoading(false);
    };

    initializeAuth();
  }, []);

  const setSession = (sessionData: any) => {
    if (sessionData) {
      setSessionState(sessionData);
      localStorage.setItem("session", JSON.stringify(sessionData));
      const token = sessionData.access_token;
      const payload = JSON.parse(window.atob(token.split(".")[1]));
      const user_role = payload.user_role;
      setRole(user_role);
      setIsAuthenticated(true);
    } else {
      setSessionState(null);
      localStorage.removeItem("session");
      setRole("");
      setIsAuthenticated(false);
    }
  };

  const verifySession = async (sessionData: any): Promise<boolean> => {
    try {
      const response = await axios.post(`${server_url}/verify`, {
        token: sessionData.access_token,
      });
      return response.data.status;
    } catch (error) {
      console.error("Error verifying session:", error);
      return false;
    }
  };



  return (
    <AuthContext.Provider
      value={{ session, role, isAuthenticated, isLoading, setSession }}
    >
      {children}
    </AuthContext.Provider>
  );
};
